export const theme = {
  token: {
    fontFamily: '"Manrope", sans-serif',
    colorPrimary: "#65A30D",
    colorInfo: "#65A30D",
    colorText: "#000",
    controlHeight: 40,
    borderRadius: 5,
    fontSize: 14,
  },
  components: {
    Button: {
      controlHeight: 40,
      defaultShadow: "none",
      //   primaryShadow: "0 6px 16px rgba(255,0,140,.25)",
      fontWeight: 500,
    },
    Input: {
      activeBorderColor: "#65A30D",
      hoverBorderColor: "#65A30D",
      // borderRadius: 6,
    },
    DatePicker: {
      // borderRadius: 6,
    },
    Select: {
      // borderRadius: 6,
      // fontSizeLG: 14,
      // colorBorder: "#eef0f3",
    },
    Divider: { margin: 4 },
  },
};
